<div class="container-box">
  <div class="flex mt-3">
    <div class="dynamic-form mx-4 my-2 w-3/12">
      <app-make-dropdown-ms
        [meta]="brandsMeta"
        [triggerSelectionBrand$]="triggerSelectionBrand$"
        [triggerUpdateComponent$]="triggerUpdateComponentSelectBrand$"
      ></app-make-dropdown-ms>
    </div>
    <div class="dynamic-form mx-4 my-2 w-9/12 text-right align-bottom">
      <app-button
        (btnClicked)="duplicateMonthMS()"
        [additionalClass]="'mb-4'"
        [content]="'Copia mese tutti i codici'"
      ></app-button>
      <app-button-new-ms [additionalClass]="'mb-4 ml-3'"></app-button-new-ms>
      <app-button
        (btnClicked)="exportExcel()"
        [additionalClass]="'mb-4 ml-3'"
        [color]="'download'"
        [content]="'Esporta Excel'"
        [faIcon]="faDownload"
        [showIcon]="true"
      ></app-button>
    </div>
  </div>
  <div class="flex">
    <div class="mx-4 my-2 w-full">
      <div class="table-container">
        <app-new-table
          (btnDetailsClickEvent)="btnDetailsClick($event)"
          (btnDeleteClickEvent)="btnDeleteClick($event)"
          [dataSource]="dataSource"
          [customButtons]="customButtons"
          [reloadTrigger$]="reloadTrigger$"
          (customActionSlideToggle)="changeTransmission($event)"
          [triggerSelectorBrand$]="triggerSelectionBrand$"
          [displayedColumns]="displayedColumns"
          [initialSort]="{ active: 'id', direction: 'desc' }"
          [additionalFilters]="{ brandId: brandIdDefault }"
        ></app-new-table>
      </div>
    </div>
  </div>
</div>
